import { ReactNode } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useCanMutate } from '../hooks';

interface MutationGateProps {
  children: ReactNode;
  reason?: string;
  /**
   * Override the default `useCanMutate()` check — e.g. pass
   * `useCanUseMeetingCapture()` for surfaces a read-only user may reach when a
   * workspace flag unlocks them.
   */
  allowed?: boolean;
}

const DEFAULT_REASON = "Read-only role can't make changes.";

export const MutationGate = ({
  children,
  reason = DEFAULT_REASON,
  allowed,
}: MutationGateProps) => {
  const canMutate = useCanMutate();

  if (allowed ?? canMutate) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            aria-disabled
            className="inline-block cursor-not-allowed [&>*]:pointer-events-none [&>*]:opacity-50"
          >
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent>{reason}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
